import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { Typeahead } from '../../Widgets/Typeahead'
import { AuditLogDetailHelper } from '../../Utils/AuditLogDetailHelper'

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string,
    urlCount: string,
    urlDetail: string,
    userList: Array<string>
}

var FILTER_DELIM = '-delim-';
const batchSize = 100;

class AuditLogBrowseRequest {
    Id: string;
    LogType: string;
    Entity: string;
    TimestampFrom: number | null;
    TimestampTo: number | null;
    ChangedBy: string;
    EntityType: string;
    Action: string;
    Result: string;
    LastId: number | null;
    BatchSize: number;
}

export class IndexPage {
    private _options: IndexPageOptions;
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: AuditLogBrowseRequest;

    private _filterType: MultiSelectApi;
    private _filterCreatedFrom: DateTimePickerApi;
    private _filterCreatedTo: DateTimePickerApi;
    private _filterEntityType: MultiSelectApi;
    private _filterAction: MultiSelectApi;
    private _filterEntityName: JQuery;
    private _filterUserName: JQuery;
    private _filterResult: MultiSelectApi;
    private _filterId: JQuery;

    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _processing: JQuery;

    constructor(options: IndexPageOptions) {
        this._options = options;
        this.run = this.run.bind(this);
        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
        this.enableRunButton = this.enableRunButton.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.getCountResult = this.getCountResult.bind(this);
        this.toggleDetail = this.toggleDetail.bind(this);

        this._filterType = new MultiSelectApi('filterType');
        this._filterCreatedFrom = new DateTimePickerApi('filterCreatedFrom');
        this._filterCreatedTo = new DateTimePickerApi('filterCreatedTo');
        this._filterEntityType = new MultiSelectApi('filterEntityType');
        this._filterEntityName = Utils.getJQueryById('filterEntityName');
        this._filterUserName = Utils.getJQueryById('filterUserName');
        this._filterAction = new MultiSelectApi('filterAction');
        this._filterResult = new MultiSelectApi('filterResult');
        this._filterId = Utils.getJQueryById('filterId');

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);
        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);
        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);

        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);
        this._totalEntries = Utils.getJQueryById("totalEntries");
        this._processing = Utils.getJQueryById("processing");

        var taOptions = {
            source: this._options.userList
        };

        var ta = new Typeahead('filterUserName', taOptions);
    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableAuditLogs").getElementsByTagName("tbody")[0];
    }

    private getBrowseRequest(): AuditLogBrowseRequest {
        let request = new AuditLogBrowseRequest();
        request.Id = this._filterId.val();
        request.LogType = this._filterType.isAllSelected() ? '' : this._filterType.getSelectionValues(FILTER_DELIM);
        request.Entity = this._filterEntityName.val();
        request.TimestampFrom = this._filterCreatedFrom.getUnixTimestamp();
        request.TimestampTo = this._filterCreatedTo.getUnixTimestamp();
        request.ChangedBy = this._filterUserName.val();
        request.EntityType = this._filterEntityType.isAllSelected() ? '' : this._filterEntityType.getSelectionValues(FILTER_DELIM);
        request.Action = this._filterAction.isAllSelected() ? '' : this._filterAction.getSelectionValues(FILTER_DELIM);
        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        request.BatchSize = batchSize + 1;
        return request;
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private loadMore(): void {
        this.sendRequest(this._currentRequest);
    }

    private resetFilter(): void {
        this._filterType.selectAll();
        var createdFrom = DateUtils.getUtcMoment().subtract(1, 'days').set({ hours: 0, minutes: 0, seconds: 0 });
        this._filterCreatedFrom.setUTCDate(createdFrom);
        var createdTo = DateUtils.getUtcMoment().endOf('day');
        this._filterCreatedTo.setUTCDate(createdTo);
        this._filterEntityType.selectAll();
        this._filterEntityName.val('');
        this._filterUserName.val('');
        this._filterAction.selectAll();
        this._filterResult.selectAll();
        this._filterId.val('');
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: "500",
            autoClose: false,
            class: "danger",
            message: "Unexpected error",
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
    }

    private getDetailUrl(detailUrl: string, data: any): string {
        return `${detailUrl}/${data}`;
    }

    private sendRequest(request: AuditLogBrowseRequest) {
        let urlList = this._options.urlList;
        let detailUrl = this._options.urlDetail;
        let getDetailUrl = this.getDetailUrl;
        let table = this.getTableBody();
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        let renderDetailRow = AuditLogDetailHelper.renderDetailRow;
        let toggleDetail = this.toggleDetail;
        processing.show();
        $.ajax({
            url: urlList,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                let items = JSON.parse(data);
                if (items.length < batchSize + 1) {
                    hideLoadMore();
                }
                else {
                    request.LastId = items[batchSize].Id;
                    showLoadMore();
                }
                let orderNo = 0;
                let previousId = 0;
                $.each(items, function (index, item) {
                    if (index < batchSize) {
                        if (previousId == item.Id) {
                            orderNo++;
                        } else {
                            orderNo = 0;
                        }
                        previousId = item.Id;
                        let row = table.insertRow(-1);
                        row.id = `auditLog${item.Id}-${orderNo}`;
                        row.className = "cursor-pointer";
                        row.onclick = () => toggleDetail(row.id);
                        let cell0 = row.insertCell(0);
                        cell0.innerHTML = `<a href='${getDetailUrl(detailUrl, item.Id)}'>${item.Id}</a>`;
                        cell0.className = `log-level-${item.Result.toLowerCase()}`;
                        let cell1 = row.insertCell(1);
                        cell1.innerHTML = `${item.Type}`;
                        let cell2 = row.insertCell(2);
                        cell2.innerHTML = `${item.Created}`;
                        let cell3 = row.insertCell(3);
                        cell3.innerHTML = `${item.EntityType}`;
                        let cell4 = row.insertCell(4);
                        cell4.innerHTML = item.EntityId == '' ? '' : item.EntityId + ` (${item.EntityName})`;
                        let cell5 = row.insertCell(5);
                        cell5.innerHTML = `${item.UserName}`;
                        let cell6 = row.insertCell(6);
                        cell6.innerHTML = `${item.Action}`;
                        let cell7 = row.insertCell(7);
                        cell7.innerHTML = `${item.Message}`;
                        let cell8 = row.insertCell(8);
                        cell8.innerHTML = `${item.Result}`;

                        let detailRow = table.insertRow(-1);
                        detailRow.setAttribute("style", "display: none");
                        detailRow.id = `auditLog${item.Id}-${orderNo}detail`;
                        let detailCell = detailRow.insertCell(0);
                        detailCell.colSpan = 9;
                        detailCell.innerHTML = renderDetailRow(item);
                        detailCell.innerHTML += `<a href='${getDetailUrl(detailUrl, item.Id)}'>View record</a>`;
                    }
                });
                processing.hide();
                enableRunButton();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                enableRunButton();
                displayMessage(jqXHR);
            }
        });
    }

    private toggleDetail(id: string) {
        let detailId = `${id}detail`;
        let detailRow = document.getElementById(detailId);
        if (detailRow.hasAttribute("style")) {
            detailRow.removeAttribute("style");
        }
        else {
            detailRow.setAttribute("style", "display: none");
        }
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/AuditLog/IndexPage.ts
 **/